/***
 *
 *   BUTTON STYLES
 *   Ported from ui-reference/src/components/ui/button.tsx (cva buttonVariants).
 *
 *   The reference exposes variant + size. This app's 63 call sites use the
 *   Gravity prop surface instead (color / outline / textOnly / small / big /
 *   iconButton), so button.js maps those onto these keys. Both vocabularies
 *   are listed below; the legacy keys are aliases, not separate designs.
 *
 **********/

const ButtonStyle = {
    base: `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium
    transition-colors duration-150 ring-offset-background focus-visible:outline-none focus-visible:ring-2
    focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50
    cursor-pointer font-sans`,

    // -- variants ----------------------------------------------------------
    primary: 'bg-primary-600 text-primary-foreground hover:bg-primary-700 active:bg-primary-800',
    secondary: 'border bg-surface text-text-primary hover:bg-primary-50 dark:hover:bg-primary-900/40',
    ghost: 'text-text-secondary hover:bg-primary-50 dark:hover:bg-primary-900/40',
    danger: 'bg-error text-white hover:brightness-95',
    accent: 'bg-accent-500 text-accent-foreground hover:bg-accent-600',

    // Not in the reference, which has no warning-coloured button. Kept because
    // this app uses color="orange" for reversible-but-consequential actions
    // (archive, unsync) where danger red overstates the risk.
    warning: 'bg-warning text-white hover:brightness-95',

    // -- sizes -------------------------------------------------------------
    sm: 'h-8 rounded-sm px-3 text-xs',
    md: 'h-10 px-4',
    lg: 'h-11 rounded-lg px-6',
    iconOnly: 'h-10 w-10 p-0',
    iconOnlySm: 'h-8 w-8 p-0',

    // -- modifiers ---------------------------------------------------------
    fullWidth: 'w-full',
    rounded: 'rounded-full',
    relative: 'relative',
    absolute: 'absolute',

    // The loading spinner is rendered as a child now rather than an ::after
    // background-image, so there is no `loading` class any more.
};

export default ButtonStyle;
